import { dashboardApi } from '@/store/api/base/api.base';
import { trafficParams } from '@/function/traffic/traffic.query';
import type { TypeRangeKey } from '@/types/begateway/types.begateway.traffic';
import type {
    TypeTrafficDimension,
    TypeTrafficQuery,
    TypeTrafficSeries,
    TypeTrafficStep,
    TypeTrafficSummary,
    TypeTrafficTop,
    TypeTrafficTopMetric,
} from '@/types/traffic/types.traffic';
import type { TypeTrafficLive } from '@/types/traffic/types.traffic.live';
import type { TypeTrafficOrigins } from '@/types/traffic/types.traffic.origin';

type TypeTrafficSeriesQuery = TypeTrafficQuery & { step?: TypeTrafficStep; groupBy?: TypeTrafficDimension };

type TypeTrafficTopQuery = TypeTrafficQuery & { by?: string; metric?: TypeTrafficTopMetric; limit?: number };

type TypeTrafficOriginsQuery = { range?: TypeRangeKey; from?: string; to?: string };

export const trafficApi = dashboardApi.injectEndpoints({
    endpoints: (build) => ({
        readTrafficSummary: build.query<TypeTrafficSummary, TypeTrafficQuery & { compare?: boolean }>({
            query: (query) => ({ url: '/traffic/summary', params: trafficParams(query) }),
            providesTags: ['Traffic'],
        }),

        readTrafficSeries: build.query<TypeTrafficSeries, TypeTrafficSeriesQuery>({
            query: (query) => ({ url: '/traffic/series', params: trafficParams(query) }),
            providesTags: ['Traffic'],
        }),

        readTrafficTop: build.query<TypeTrafficTop, TypeTrafficTopQuery>({
            query: (query) => ({ url: '/traffic/top', params: trafficParams(query) }),
            providesTags: ['Traffic'],
        }),

        readTrafficLive: build.query<TypeTrafficLive, number | void>({
            query: (limit) => ({ url: '/traffic/live', params: { limit: limit ?? 25 } }),
            providesTags: ['Traffic'],
        }),

        readTrafficOrigins: build.query<TypeTrafficOrigins, TypeTrafficOriginsQuery>({
            query: (query) => ({ url: '/traffic/origins', params: trafficParams(query) }),
            providesTags: ['Traffic'],
        }),

    }),
});

export const {
    useReadTrafficSummaryQuery,
    useReadTrafficSeriesQuery,
    useReadTrafficTopQuery,
    useReadTrafficLiveQuery,
    useReadTrafficOriginsQuery,
} = trafficApi;
